<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <!-- <h1>Details</h1> -->
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>
    <!-- <div class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <template>
                  <vue-highcharts
                    :options="routerUsageHighChartOptions"
                    ref="lineCharts"
                  ></vue-highcharts>
                </template>
              </div>
              <div class="col-md-6">
                <template>
                  <vue-highcharts
                    :options="totalUsageSummaryHighChartOptions"
                    ref="totalUsageSummaryLineCharts"
                  ></vue-highcharts>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Device Occurance -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <h3 style="margin-left: 20px; padding-top: 12px" class="card-title">
            Violations
          </h3>
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(occuranceList.data) && is_loading_occurance == false"
          >
            <div class="btn-toolbar pull-left">
              <button
                class="btn btn-info"
                type="button"
                @click="showOccuranceFilter = !showOccuranceFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>

            <div class="card-tools">
              <button class="btn btn-outline" @click="exportOccuranceFile()">
                <i class="icon-download"></i> Export
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading_occurance">
            <img src="/assets/images/loader.svg" alt="" />
          </div>

          <form @submit.prevent="getOccuranceFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showOccuranceFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!--  Device MAC -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="Device_MAC"
                      >Device MAC</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="Device_MAC"
                          name="Device_MAC"
                          v-model="occuranceFilter.Device_MAC"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="Device MAC"
                        />
                      </div>
                    </div>
                  </div>

                  <div style="display: none" class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="Category">Category</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="destination_hosts"
                          name="destination_hosts"
                          v-model="occuranceFilter.destination_hosts"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="Category"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="Message">Message</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="Message"
                          name="Message"
                          v-model="occuranceFilter.Message"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="Message"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="Time">Date</label>
                    <div class="col-md-9">
                      <date-picker
                        autocomplete="off"
                        id="Time"
                        name="Time"
                        v-model="occuranceFilter.Time"
                        class=""
                        placeholder="Time"
                        valueType="format"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="row justify-content-end">
                    <div class="col-md-9">
                      <button type="submit" class="btn btn-common mr-3">
                        <i class="icon-search"></i> Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-outline"
                        @click="resetOccuranceFilter()"
                      >
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <h6>Total Item: {{ occuranceList.total }}</h6>
            <div v-if="!_.isEmpty(occuranceList.data) && is_loading_occurance == false">
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Device Name</th>
                      <th>Device MAC</th>
                      <th>Category</th>
                      <th>Message</th>
                      <th>Time</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="occuranceList">
                    <tr v-for="(val, index) in occuranceList.data">
                      <td>{{ val.Name }}</td>
                      <td>{{ val.Device_MAC }}</td>
                      <td>{{ formatCategory(val.destination_hosts) }}</td>
                      <td>{{ val.Message }}</td>
                      <td>{{ val.TimeNew }}</td>
                      <td class="text-right">
                        <router-link
                          v-if="actionView == true"
                          :to="{
                            name: 'OccuranceShow',
                            params: { id: val.id },
                          }"
                          class="btn btn-view"
                        >
                          <i class="icon-eye"></i>
                        </router-link>

                        <a
                          v-if="actionDelete == true || checkDeletePermission(val)"
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="deleteOccuranceObject(val.id, index)"
                          ><i class="icon-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>
            <div
              class="p-4"
              v-if="_.isEmpty(occuranceList.data) && is_loading_occurance == false"
            >
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div>Showing {{ showingText }}</div>
            <vue-pagination
              :pagination="occuranceList"
              v-if="occuranceList.total > occuranceList.per_page"
              @paginate="reloadOccurance()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <h3 class="card-title">Device List</h3>
            <div class="btn-toolbar pull-right">
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!-- Device MAC -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="Device_MAC"
                      >DEVICE MAC</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="Device_MAC"
                          name="Device_MAC"
                          v-model="filter.Device_MAC"
                          :class="{
                            'has-error': errors.has('Device_MAC'),
                          }"
                          class="form-control"
                          placeholder="Device MAC"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- IP Address -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="ip_address">IP</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="ip_address"
                          name="ip_address"
                          v-model="filter.ip_address"
                          :class="{
                            'has-error': errors.has('ip_address'),
                          }"
                          class="form-control"
                          placeholder="IP"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Device Name -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="Name">Device Name</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="Name"
                          name="Name"
                          v-model="filter.Name"
                          :class="{
                            'has-error': errors.has('Name'),
                          }"
                          class="form-control"
                          placeholder="Device Name"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Group Name -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="group_name"
                      >Group Name</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="group_name"
                          name="group_name"
                          v-model="filter.group_name"
                          :class="{
                            'has-error': errors.has('group_name'),
                          }"
                          class="form-control"
                          placeholder="Group Name"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row justify-content-end">
                    <div class="col-md-9">
                      <button type="submit" class="btn mr-3">
                        <i class="icon-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-outline" @click="resetFilter()">
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <h6>Total Item: {{ list.total }}</h6>
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Mac</th>
                      <th>IP</th>
                      <th>Group</th>
                      <th>Status</th>
                      <!-- <th>Usage Today</th> -->
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td>{{ val.Name }}</td>

                      <td v-if="val.upload != '0' || val.download != '0'">
                        <router-link
                          :to="{
                            name: 'DeviceUsage',
                            params: {
                              accountId: val.accountId,
                              device_mac: val.Device_MAC,
                            },
                          }"
                          class="link-cell"
                          >{{ val.Device_MAC }}
                        </router-link>
                      </td>
                      <td v-else>
                        {{ val.Device_MAC }}
                      </td>
                      <td>{{ val.ip_address }}</td>
                      <td>{{ val.group_name }}</td>
                      <td>{{ val.status }}</td>
                      <!-- <td>{{ processUsage(val) }}</td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
import VueHighcharts from "vue2-highcharts";
// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";

export default {
  name: "CustomDevice",
  metaInfo: {
    title: "Details | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    VueHighcharts,
  },

  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    occuranceList: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: false,
    actionView: false,
    actionEdit: false,
    actionDelete: true,
    api_url: "",
    showFilter: false,
    showOccuranceFilter: false,
    filter: {},
    occuranceFilter: {},
    dateRange: "",
    pre: {},
    is_loading: false,
    is_loading_occurance: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    routerUsage: "",
    totalUsageSummary: "",

    routerUsageHighChartOptions: {
      chart: {
        type: "spline",
      },
      title: {
        text: "Bandwidth Graph (Last 1 hour)",
        style: {
          fontFamily: "Inter",
          fontSize: "16px",
          fontWeight: "500",
          color: "#1e2d2c",
        },
      },
      subtitle: {
        text: null,
      },
      xAxis: {
        // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        //   'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        categories: [],
        title: {
          // text: "Time",
        },
      },
      yAxis: {
        title: {
          text: "Kbps",
          style: {
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: "500",
            color: "#1e2d2c",
          },
        },
        // labels: {
        //   formatter: function () {
        //     return this.value + '°';
        //   }
        // }
      },
      tooltip: {
        crosshairs: true,
        shared: true,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        spline: {
          marker: {
            radius: 4,
            lineColor: "#666666",
            lineWidth: 1,
          },
        },
      },
      series: [],
    },

    totalUsageSummaryHighChartOptions: {
      chart: {
        type: "spline",
      },
      title: {
        text: "Usage Graph (Last 7 days)",
        style: {
          fontFamily: "Inter",
          fontSize: "16px",
          fontWeight: "500",
          color: "#1e2d2c",
        },
      },
      subtitle: {
        text: "",
      },
      xAxis: {
        categories: [],
        style: {
          fontFamily: "Inter",
          fontSize: "12px",
          fontWeight: "500",
          color: "#1e2d2c",
        },
        title: {
          text: "",
        },
      },
      yAxis: {
        title: {
          text: "GB",
          style: {
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: "500",
            color: "#1e2d2c",
          },
        },
        // labels: {
        //   formatter: function () {
        //     return this.value + '°';
        //   }
        // }
      },
      tooltip: {
        crosshairs: true,
        shared: true,
        style: {
          fontFamily: "Inter",
          fontSize: "12px",
          fontWeight: "500",
          color: "#1e2d2c",
        },
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        spline: {
          lineColor: "#00a99c",
          marker: {
            radius: 4,
            lineColor: "#00a99c",
            fillColor: "#00a99c",
            lineWidth: 1,
          },
        },
      },
      series: [],
    },
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/customDeviceSearch";
    this.filter = this.$route.params;

    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
    showingText() {
      const start =
        (this.occuranceList.current_page - 1) * this.occuranceList.per_page + 1;
      const end = Math.min(
        this.occuranceList.current_page * this.occuranceList.per_page,
        this.occuranceList.total
      );
      return `${start} to ${end} of ${this.occuranceList.total} entries`;
    },
  },
  methods: {
    async initialize() {
      const _this = this;
      this.is_loading = true;
      this.is_loading_occurance = true;
      this.user_detail = this.profile;

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/devices"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      // }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      await this.getOccuranceList()
        .then((response) => {
          this.occuranceList = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      // await this.getRouterUsage()
      //   .then((response) => {
      //     this.routerUsage = response.data;
      // this.setRouterUsageChartData();
      // })
      // .catch((error) => {
      //   this.empty = true;
      // if (error.response.status === 403) {
      //   this.has_permission = false;
      // }
      //   console.log(error);
      // });

      // await this.getTotalUsageSummary()
      //   .then((response) => {
      //     this.totalUsageSummary = response.data;

      // this.totalUsageSummaryChartData.datasets[0].data = this.totalUsageSummary.data
      // this.totalUsageSummaryChartData.labels = this.totalUsageSummary.label
      // _this.setTotalUsageSummaryChart();
      // })
      // .catch((error) => {
      //   this.empty = true;
      //   if (error.response.status === 403) {
      //     this.has_permission = false;
      //   }
      // });

      this.is_loading = false;
      this.is_loading_occurance = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            this.is_loading = false;
          });
      });
    },
    async getOccuranceFilterData() {
      this.occuranceList.current_page = 1;
      this.is_loading_occurance = true;
      await this.getOccuranceList()
        .then((response) => {
          this.occuranceList = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading_occurance = false;
    },
    reloadOccurance: function () {
      this.getOccuranceList()
        .then((response) => {
          this.occuranceList = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getOccuranceList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.occuranceList.current_page };
        params = {
          ...this.occuranceFilter,
          userAccountId: this.$route.params.accountId,
          ...params,
        };
        axios
          .get("/occurances", {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },

    async resetOccuranceFilter() {
      this.occuranceList.current_page = 1;
      this.occuranceFilter = {};
      this.is_loading_occurance = true;
      await this.getOccuranceList()
        .then((response) => {
          this.occuranceList = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading_occurance = false;
    },
    deleteOccuranceObject: function (id, index) {
      const _this = this;
      const delete_api_url = "/occurances/" + id;

      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading_occurance = true;
            axios
              .delete(delete_api_url)
              .then((response) => {
                _this.occuranceList.data.splice(index, 1);
                _this.occuranceList.total -= 1;
                _this.$toaster.success(response.data.message);
              })
              .catch((error) => {
                console.log(error);
                _this.$swal.fire("Failed!", "failed to delete.", "error");
              })
              .finally(() => {
                _this.is_loading_occurance = false;
              });
          }
        });
    },
    exportOccuranceFile: function () {
      this.is_loading_occurance = true;
      axios
        .get("/occurances-export", {
          params: {
            ...this.occuranceFilter,
            userAccountId: LocalStorage.get("accountId"),
          },
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "occurances.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading_occurance = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },
    processUsage(val) {
      if (val.upload > 0 || val.download > 0) {
        // console.log("in process");
        // console.log(val);
        return (val.upload / 1024 / 1024 + val.download / 1024 / 1024).toFixed(2) + " MB";
      }
      return "0 MB";
    },

    getRouterUsage() {
      return new Promise((resolve, reject) => {
        axios
          .get("/routerUsage/" + this.$route.params.accountId)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },

    getTotalUsageSummary() {
      return new Promise((resolve, reject) => {
        axios
          .get("/totalusagesummary/" + this.$route.params.accountId)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    setRouterUsageChartData() {
      let Gbflag = 0;
      let Mbflag = 0;
      const arrayLength = this.routerUsage.length;
      let download = 0;
      let upload = 0;
      const categories = [];

      const downloadData = {
        name: "Download",

        marker: {
          symbol: "circle",
        },
        data: [],
      };

      const uploadData = {
        name: "Upload",
        marker: {
          symbol: "circle",
        },
        data: [],
      };

      for (let i = 0; i < arrayLength; i++) {
        const item = this.routerUsage[i];
        download =
          item.timeinterval > 0 ? (item.download / item.timeinterval).toFixed(2) : 0;
        upload = item.timeinterval > 0 ? (item.upload / item.timeinterval).toFixed(2) : 0;
        if (isNaN(download) || !download) download = 0;
        if (isNaN(upload) || !upload) upload = 0;
        if (download > 1000) {
          if (parseInt(download / 1000) > 1000) Gbflag = 1;
          else Mbflag = 1;
        }

        if (upload > 1000) {
          if (parseInt(upload / 1000) > 1000) Gbflag = 1;
          else Mbflag = 1;
        }
      }

      for (let i = 0; i < arrayLength; i++) {
        const item = this.routerUsage[i];
        download =
          item.timeinterval > 0 ? (item.download / item.timeinterval).toFixed(2) : 0;
        upload = item.timeinterval > 0 ? (item.upload / item.timeinterval).toFixed(2) : 0;
        if (Gbflag == 1) {
          download = (download / 1000 / 1000).toFixed(2);
          upload = (upload / 1000 / 1000).toFixed(2);
        } else if (Mbflag == 1) {
          download = (download / 1000).toFixed(2);
          upload = (upload / 1000).toFixed(2);
        }

        if (isNaN(download) || !download) download = 0;
        if (isNaN(upload) || !upload) upload = 0;

        categories.push(item.StartTime.slice(0, -3));
        downloadData.data.push(parseInt(download));
        uploadData.data.push(parseInt(upload));
      }

      const lineCharts = this.$refs.lineCharts;

      lineCharts.delegateMethod("showLoading", "Loading...");
      lineCharts.addSeries(downloadData);
      lineCharts.addSeries(uploadData);

      lineCharts.getChart().xAxis[0].setCategories(categories);
      if (Gbflag == 1) {
        lineCharts.getChart().yAxis[0].setTitle({ text: "Gbps" });
      } else if (Mbflag == 1) {
        lineCharts.getChart().yAxis[0].setTitle({ text: "Mbps" });
      } else {
        lineCharts.getChart().yAxis[0].setTitle({ text: "Kbps" });
      }

      lineCharts.hideLoading();
    },

    setTotalUsageSummaryChart() {
      const totalData = {
        name: "Total",

        marker: {
          symbol: "circle",
        },
        data: this.totalUsageSummary.data,
      };
      const lineCharts = this.$refs.totalUsageSummaryLineCharts;

      lineCharts.delegateMethod("showLoading", "Loading...");
      lineCharts.addSeries(totalData);

      lineCharts.getChart().xAxis[0].setCategories(this.totalUsageSummary.label);

      lineCharts.hideLoading();
    },
    formatCategory(category) {
      // Remove leading and trailing underscores
      category = category.replace(/^_+|_+$/g, "");
      // Replace "--" with a space
      category = category.replace(/--/g, " ");
      // Replace remaining underscores with a space
      category = category.replace(/_/g, " ");
      return category;
    },
    formatTime(timeString) {
      const date = new Date(timeString);
      const formattedTime = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date
        .getDate()
        .toString()
        .padStart(2, "0")} ${date
        .getHours()
        .toString()
        .padStart(2, "0")}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
      return formattedTime;
    },
  },
  /* created() {
      this.$emit("update:layout", MasterLayout);
    }, */
};
</script>

<style scoped>
.link-cell {
  cursor: pointer;
  color: #00a79c;
  text-decoration: underline;
  font-weight: bold;
}
</style>
